// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cVU6JAkMuSol_K {
  display: inline;
  color: var(--ds-link, #0c66e4);
  cursor: pointer;
}
.cVU6JAkMuSol_K:hover {
  text-decoration: underline;
}
.HQrhZfZ6zTRU0K {
  color: var(--ds-text, #172b4d);
  cursor: default;
}
.HQrhZfZ6zTRU0K:hover {
  text-decoration: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attachmentLink": `cVU6JAkMuSol_K`,
	"maliciousAttachment": `HQrhZfZ6zTRU0K`
};
export default ___CSS_LOADER_EXPORT___;
